import { render, staticRenderFns } from "./PromoTraining.vue?vue&type=template&id=10209308&scoped=true&"
import script from "./PromoTraining.vue?vue&type=script&lang=js&"
export * from "./PromoTraining.vue?vue&type=script&lang=js&"
import style0 from "./PromoTraining.vue?vue&type=style&index=0&id=10209308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10209308",
  null
  
)

export default component.exports